// ACTION TYPES
export const actionTypes = {
    SAVE_CHURCH_VIDEO_REQUEST: "SAVE_CHURCH_VIDEO_REQUEST",
    SAVE_CHURCH_VIDEO_SUCCESS: "SAVE_CHURCH_VIDEO_SUCCESS",
    SAVE_CHURCH_VIDEO_FAILURE: "SAVE_CHURCH_VIDEO_FAILURE",
  
    UPDATE_CHURCH_VIDEO_REQUEST: "UPDATE_CHURCH_VIDEO_REQUEST",
    UPDATE_CHURCH_VIDEO_SUCCESS: "UPDATE_CHURCH_VIDEO_SUCCESS",
    UPDATE_CHURCH_VIDEO_FAILURE: "UPDATE_CHURCH_VIDEO_FAILURE",
  
    DELETE_CHURCH_VIDEO_REQUEST: "DELETE_CHURCH_VIDEO_REQUEST",
    DELETE_CHURCH_VIDEO_SUCCESS: "DELETE_CHURCH_VIDEO_SUCCESS",
    DELETE_CHURCH_VIDEO_FAILURE: "DELETE_CHURCH_VIDEO_FAILURE",
  
    READ_CHURCH_VIDEO_REQUEST: "READ_CHURCH_VIDEO_REQUEST",
    READ_CHURCH_VIDEO_SUCCESS: "READ_CHURCH_VIDEO_SUCCESS",
    READ_CHURCH_VIDEO_FAILURE: "READ_CHURCH_VIDEO_FAILURE",
  };
  
  // ACTIONS
  export const saveChurchVideoRequest = (apiPayloadRequest, callback) => ({
    type: actionTypes.SAVE_CHURCH_VIDEO_REQUEST,
    payload: { apiPayloadRequest },
    callback,
  });
  
  export const updateChurchVideoRequest = (apiPayloadRequest, callback) => ({
    type: actionTypes.UPDATE_CHURCH_VIDEO_REQUEST,
    payload: { apiPayloadRequest },
    callback,
  });
  
  export const deleteChurchVideoRequest = (payload, callback) => ({
    type: actionTypes.DELETE_CHURCH_VIDEO_REQUEST,
    payload,
    callback,
  });
  
  export const readChurchVideoRequest = (payload, callback) => ({
    type: actionTypes.READ_CHURCH_VIDEO_REQUEST,
    payload,
    callback,
  });
  